/**
 * Grid overlay component that creates the border lines between stat cards
 */
export function GridOverlay() {
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-60">
      <div className="relative h-[150%] w-full">
        {/* Vertical gradient line */}
        <div className="absolute left-1/2 top-0 h-full w-px -translate-x-0.5 transform bg-gradient-to-b from-transparent via-white/70 to-transparent"></div>
        {/* Horizontal gradient line */}
        <div className="absolute left-0 top-1/2 h-px w-full -translate-y-0.5 transform bg-gradient-to-r from-transparent via-white/70 to-transparent"></div>
      </div>
    </div>
  );
}